<template>
    <div>
        <modal
            class="new-modal-small"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="200"
            :min-width="400"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important" 
            v-bind:click-to-close="false">
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center" style="background-color: #fff !important;height: auto !important;padding: 20px 0px 26px 0px;">
                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/snake.svg" style="height: 10rem !important"/>
                <div class="mt-5 px-5 text-center fw-500 fs-14">
                    <div class="mb-4 text-black fw-600 text-center" style="font-size: 25px;">Date expired alert!</div>
                    The creation date of the campaign has expired. Please ask 
                    creator to edit the start date & resend it for approval - as of now this 
                    goes under rejection.
                </div>
                <div v-if="disableButtonAndDisplayLoader == false" class="d-flex aligin-items-center justify-content-center mt-6">
                    <button class="btn new-cancel-button px-4" @click="hideSelf">Cancel</button>
                    <button class="btn new-save-button ml-4 px-4" @click="confirmSubmit">Submit</button>
                </div>
                <div v-else class="d-flex aligin-items-center justify-content-center mt-6">
                    <button class="btn new-cancel-button px-4" disabled style="border: none !important;">Cancel</button>
                    <button class="btn new-save-button ml-4 px-4" disabled style="position: relative;">Submit
                        <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { HollowDotsSpinner } from "epic-spinners";
export default {
    props: ["modal_name"],
    components: {
        HollowDotsSpinner,
    },
    data() {
        return {
            disableButtonAndDisplayLoader: false,
        }
    },
    methods: {
        hideSelf() {
            this.$emit("closeExpiredCampaign");
            this.$modal.hide(this.modal_name);
        },
        confirmSubmit() {
            this.disableButtonAndDisplayLoader = true;
            this.$emit("rejectExpiredCampaigns");
            setTimeout(() => {
                this.disableButtonAndDisplayLoader = false;
                this.$modal.hide(this.modal_name);
            }, 1500);
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/Campaign/Email/ExpiredCampaignAlert.vue